<template>
	<div id="main">
		<div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
						<div class="bootbox-body">
							<section class="panel">
								<div class="panel-body">
									<div class="row form-group">
										<div class="col-md-12 text-right form-inline" >
											<a href="javascript:;" class="btn btn-danger m-xs" @click="resItem.sno=null; resItem.name=''; resItem.total=0; isAddPopupShow=true;">新增</a>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<table class="col-md-12 table-bordered">
												<thead>
													<tr>
														<td colspan="2" style="width:40%; text-align:center;">編輯</td>
														<td style="width:20%; text-align:center;">物品</td>
														<td style="width:20%; text-align:center;">數量</td>
														<td style="width:20%; text-align:center;">剩餘數量</td>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(item, index) in resList" :key="index">
														<td style="text-align:center;">
															<a href="javascript:;" class="btn btn-link" @click="resItem=item; isAddPopupShow=true;">修改</a>
														</td>
														<td style="text-align:center;">
															<a href="javascript:;" class="btn btn-link" @click="deleteRes(item.sno)">刪除</a>
														</td>
														<td style="text-align:center;">{{item.name}}</td>
														<td style="text-align:center;">{{item.total}}</td>
														<td style="text-align:center;">{{item.remainder}}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="addPopup" v-if="isAddPopupShow">
			<div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
				<div class="modal-dialog">
					<div class="modal-content">
						<div class="modal-body">
							<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="isAddPopupShow = false">×</button>
							<div class="bootbox-body">
								<section class="panel">
									<div class="panel-body">
										<div class="row form-group">
											<div class="col-md-6">
												<label for="" class="col-md-4">物品名稱</label>
												<div class="col-md-8">
													<input type="hidden" v-model.number="resItem.sno" />
													<input type="text" class="form-control" name="" v-model="resItem.name" maxlength="10"/>
												</div>
												
											</div>
											<div class="col-md-6">
												<label for="" class="col-md-4">物品數量</label>
												<div class="col-md-8">
													<input type="number" class=" form-control" v-model.number="resItem.total"/>
												</div>
												
											</div>
										</div>
										<div class="row form-group">
											<div class="col-md-offset-10 col-md-2 text-left">
												<button type="button" class="btn btn-danger btn-block" @click="modifyRes()">新增</button>
											</div>
										</div>
									</div>
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return{
			resList:[],
			isAddPopupShow:false,
			modifyUrl:"",
			resItem:{},
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _this = this;
			const api = "/api/ResBorrom/ResList";
			this.$axios.post(api, JSON.stringify({})).then(resp => {
				_this.resList = resp.data.data;
			});
		},
		deleteRes(sno){
			let _this = this;
			const api = `/api/ResBorrom/delResData/${sno}`;
			this.$axios.delete(api).then(resp => {
				bootbox.alert(resp.data.msg, function(){
					if(resp.data.status == "success"){
						_this.init();
					}
				});
			});
		},
		modifyRes(){
			let _this = this;
			let param = this.resItem;
			this.$axios.post(`/api/ResBorrom/editResData`, JSON.stringify(param)).then(resp => {
				bootbox.alert(resp.data.msg, function(){
					if(resp.data.status == "success"){
						_this.init();
						_this.isAddPopupShow = false;
					}
				});
			});
		},
		closePopup() {
			this.$parent.showPopupControl(false);
		}
	}
}
</script>
<style scoped>
@media only screen and (max-device-height : 667px){
	.bootbox-body{
		max-height:480px;
		overflow-y:auto;
	}
}
@media only screen and (max-device-height : 736px) {
	.bootbox-body{
		max-height:600px;
		overflow-y:auto;
	}
}
@media only screen and (min-device-height : 736px) {
	.bootbox-body{
		max-height:620px;
		overflow-y:auto;
	}
}
</style>